import {dataTestId} from '@hconnect/uikit'
import {IconButton} from '@mui/material'
import React from 'react'

interface PlantStructureActionButtonProps {
  shouldBeDisplayed: boolean
  testId?: string
  icon: React.ReactNode
  handleEvent: (event: React.MouseEvent) => void
}

export const PlantStructureActionButton: React.FC<PlantStructureActionButtonProps> = ({
  shouldBeDisplayed,
  testId,
  icon,
  handleEvent
}) => {
  return (
    shouldBeDisplayed && (
      <IconButton className="icon-button" onClick={handleEvent} {...dataTestId(testId!)}>
        {icon}
      </IconButton>
    )
  )
}
